module.exports = __webpack_public_path__ + "static/media/sportsmanship.edb75635.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sportsmanship.png
// module id = 259
// module chunks = 0